// Persist request identity, not files or credentials. Owner-scoped to avoid cross-login replay.
export const intakeChanged = () => window.dispatchEvent(new Event('accounting:intake-changed'));
export const transactionsChanged = () => window.dispatchEvent(new Event('accounting:transactions-changed'));
export const newRequestKey = () => crypto.randomUUID();
export function ownerScope() {
  try {
    const payload = localStorage.getItem('access_token').split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return String(JSON.parse(atob(payload)).sub);
  } catch { return 'signed-out'; }
}
export const requestStorageKey = (kind) => `accounting:intake:${ownerScope()}:${kind}`;
export const localToday = () => {
  const now = new Date();
  return new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};
export const dollars = (amount) => Number(amount || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
export const fundingIds = (funding = {}) => ({ account_id: funding.account_id || '',
  category_id: funding.category_id || '', split_template_id: funding.split_template_id || '' });
